




import { Component, Mixins } from "vue-property-decorator";
import { IItem, instanceOfITextCopyable } from "../../../../domain/document/items";
import { ClipboardUtility, IClipboardAccessible } from "../../../../utilities";

@Component
export default class ClipboardAdapter extends Mixins() {
  data(): any {
    return {
      accessor: ClipboardUtility.createAccessor(),
      value: null,
      lastClipboardText: null,
    };
  }
  accessor: IClipboardAccessible;
  value: string | IItem;
  lastClipboardText: string;  // value更新時のclipboardのtext.(clipboard更新判定用.)

  mounted(): void {
    // 現状clipboardの更新判定(refresh)はpaste時に行ってるが、万が一pasteの前に同じtextをコピーされてると誤判定する.
    // (日付コピー等文字列以外の情報の後に実際には文字列等コピーされてたとしても、それがなかった事になってしまう.)
    // 狙ってやらないとまずそういう状態にはなりそうにないので現状対策はしてない.
    // 対策必要な場合は、あまり回り過ぎないタイマ(1秒くらい？)をしかけてrefreshする事.
  }

  async copy(value: string | IItem = null): Promise<void> {
    if (!value) { // 値未指定時
      this.accessor.writeSelectedText();
    } else {
      if (typeof(value) === "string") { // 文字列指定時.
        this.writeTextToClipboard(value);
      } else if (instanceOfITextCopyable(value)) {  // 文字列コピー可能なitem.
        this.writeTextToClipboard(value.textToCopy);
      }
      this.lastClipboardText = await this.accessor.readText();
      this.value = value;
    }
  }

  private writeTextToClipboard(text: string): void {
    // 1x1の透明なtextareaに入力した文字列を全選択してから選択文字列をclipboardに書く.(表示されてないと全選択できない.)
    // (元選択されてたtextが解除されてしまう副作用があるので、利用シーンには注意が必要.)
    const textArea = this.$refs.temporary as HTMLTextAreaElement; 
    textArea.value = text;
    textArea.select();
    this.accessor.writeSelectedText();
  }

  async paste(): Promise<string | IItem> {
    await this.refresh();
    return this.value;
  }

  async refresh(): Promise<void> {
    try {
      // clipboardが更新されていたらvalueを更新する.
      const clipboardText = await this.accessor.readText();
      if (this.lastClipboardText !== clipboardText) {
        this.value = clipboardText;
        this.lastClipboardText = clipboardText;
      }
    } catch (e) {
      this.$logger.error(e);
    }
  }
}
